import { PeriodOption, SubPeriodOption, PeriodLabelType } from './types';

/** Type 1: "Today" = start of today to end of today (single day). */
const PERIOD_OPTIONS_TYPE_1: PeriodOption[] = [
  { id: 'today', label: 'Today' },
  { id: 'thisWeek', label: 'This Week' },
  { id: 'month', label: 'Monthly', hasSubMenu: true },
  { id: 'quarter', label: 'Quarterly', hasSubMenu: true },
  { id: 'half', label: 'Half Yearly', hasSubMenu: true },
  { id: 'year', label: 'Full Financial Year' },
  { id: 'custom', label: 'Custom Date' }
];

/** Type 2: "Till Today" (id tilltoday) = FY start to end of today; distinct from today (start→end of day). */
const PERIOD_OPTIONS_TYPE_2: PeriodOption[] = [
  { id: 'tilltoday', label: 'Till Today' },
  { id: 'month', label: 'Month End', hasSubMenu: true },
  { id: 'quarter', label: 'Quarter End', hasSubMenu: true },
  { id: 'half', label: 'Half Year End', hasSubMenu: true },
  { id: 'year', label: 'Financial Year End' },
  { id: 'custom', label: 'Custom' }
];

/** Get main period options by type. 1 = Today (start→end of day), 2 = Till Today (FY start→end of today). Default 2. */
export function getPeriodOptions(type: PeriodLabelType = 2): PeriodOption[] {
  return type === 1 ? PERIOD_OPTIONS_TYPE_1 : PERIOD_OPTIONS_TYPE_2;
}

/** @deprecated Use getPeriodOptions(type) instead. Kept for backwards compatibility. */
export const PERIOD_OPTIONS: PeriodOption[] = PERIOD_OPTIONS_TYPE_1;

export const MONTHS: SubPeriodOption[] = [
  { id: 4, label: 'April' },
  { id: 5, label: 'May' },
  { id: 6, label: 'June' },
  { id: 7, label: 'July' },
  { id: 8, label: 'August' },
  { id: 9, label: 'September' },
  { id: 10, label: 'October' },
  { id: 11, label: 'November' },
  { id: 12, label: 'December' },
  { id: 1, label: 'January' },
  { id: 2, label: 'February' },
  { id: 3, label: 'March' }
];

export const QUARTERS: SubPeriodOption[] = [
  { id: 'Q1', label: 'Q1 (Apr-Jun)' },
  { id: 'Q2', label: 'Q2 (Jul-Sep)' },
  { id: 'Q3', label: 'Q3 (Oct-Dec)' },
  { id: 'Q4', label: 'Q4 (Jan-Mar)' }
];

export const HALVES: SubPeriodOption[] = [
  { id: 'H1', label: 'H1 (Apr-Sep)' },
  { id: 'H2', label: 'H2 (Oct-Mar)' }
];

export const CAL_MONTH_LABELS = [
  { id: 1, label: 'Jan' }, { id: 2, label: 'Feb' }, { id: 3, label: 'Mar' },
  { id: 4, label: 'Apr' }, { id: 5, label: 'May' }, { id: 6, label: 'Jun' },
  { id: 7, label: 'Jul' }, { id: 8, label: 'Aug' }, { id: 9, label: 'Sep' },
  { id: 10, label: 'Oct' }, { id: 11, label: 'Nov' }, { id: 12, label: 'Dec' },
];